import React, { Component } from "react";
import PropTypes from "prop-types";
import { convertStringToElements } from "@vds/html-parsers";
import { TitleLockup } from "@vds/type-lockups";
import { Feature,Body,Title } from "@vds/typography"
import styled from "styled-components";
import { connect } from "react-redux";
import { compose } from "redux";
import Button from "common-components/Buttons";

import { setA11yContent } from "../../NavigationHelper/actions";
import { media,isMobile } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";
import Alert from "common-components/Alert";
import CommonContainer from "common-components/Container";
import FallbackUI from "../../FallbackUI/FallbackUI";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import { fetchPageContent } from "../../DownloadAndDelete/actions";
import { ENDPOINTS } from "utils/endpoints";
import { FormerCustomerDeleteModal } from "../../FormerCustomer/modals";
import StyledLink from "../../../../common/StyledLink";

class GuestFlowDeleteInfo extends Component {
  state = {
    visibleModal: false
  };

  componentDidMount() {
    let url = ENDPOINTS.FETCH_GUEST_DELETE_PAGE_NEW;
    this.props.fetchPageContent(url).then(() => {
      if (checkNestedObject(this.props.guestDeletePrimerPage, "sc_pagetitle")) {
        this.props.setA11yContent("guest delete information", this.props.guestDeletePrimerPage.sc_pagetitle);
      }
    });
  }

  handleModalPopup = () => {
    this.setState({ visibleModal: !this.state.visibleModal });
  };

  handleDeleteClick = () => {
    this.props.history.push({
      pathname: "email-info",
      state: { serviceType: "guest", currentIntent: "delete" }
    });
  }

  render() {
    if (this.props.loading) {
      return <RectangleLoader />;
    }
    const { guestDeletePrimerPage, modalContent } = this.props;
    let pageContent = guestDeletePrimerPage;
    if (this.props.error) {
      return <FallbackUI />;
    } else if (!pageContent) {
      return <FallbackUI />;
    } else {
      return (
        <div>
          <Container noTabletPadding>
            {this.props.error ? <Alert alertType="error">{this.props.error}</Alert> : null}
          <div style={{ maxWidth: "620px" }}>
            {/* VDS DPCMP-3786 ,DPCMP-3784 */}

            <TitleLockup
                  viewport={isMobile ? "mobile": "desktop"}
                  data={{
                  title: {
                    size: 'titleXLarge',
                    bold: false,
                    // primitive: 'h1',
                    children: pageContent.section_title
                  },
                  subtitle : {
                    size: 'titleMedium',
                    primitive: 'p',
                    children: <HeaderDesc>{convertStringToElements(pageContent.section_description)}</HeaderDesc>
                  }                  
                  }}
              />
            </div>
           
            <ButtonContainer>
              {/* <StyledLink background={pageContent.buttons[0].type} onClick={this.handleModalPopup}>
                {pageContent.buttons[0].text}
              </StyledLink>
              <StyledLink
                role="link"
                background={pageContent.buttons[1].type}
                onClick={() => this.props.history.goBack()}
              >
                {pageContent.buttons[1].text}
              </StyledLink> */}
              <Button
                onClick={this.handleModalPopup}
                background={pageContent.buttons[0].type}
                aria-label={pageContent.buttons[0].text}
              >  {pageContent.buttons[0].text}</Button>
              <Button
                background={pageContent.buttons[1].type}
                onClick={() => this.props.history.goBack()}
                aria-label={pageContent.buttons[1].text}
              >  {pageContent.buttons[1].text}</Button>
            </ButtonContainer>
          </Container>
          {this.state.visibleModal && (
            <FormerCustomerDeleteModal
              visibleModal={this.state.visibleModal}
              closeModal={this.handleModalPopup}
              modalContent={modalContent}
              currentIntent="delete"
              serviceType={this.props.location.state.serviceType}
              handleDeleteClick={this.handleDeleteClick}
            />
          )}
        </div>
      );
    }
  }
}

const mapStateToProps = ({
  pageContent: {
    delete_information_guest: guestDeletePrimerPage,
    delete_review_guest: modalContent,
    delete_confirmation_guest: deleteConfirmationPage,
    pending_modal: requestPending,
  },
  loadingAndErrorState: { loading, error },
  pendingCase: { isCasePending },
}) => ({
  modalContent,
  guestDeletePrimerPage,
  deleteConfirmationPage,
  loading,
  error,
  isCasePending,
  requestPending
});

export default compose(
  connect(
    mapStateToProps,
    {
      setA11yContent,
      fetchPageContent,
    }
  ),
)(GuestFlowDeleteInfo);

GuestFlowDeleteInfo.propTypes = {
  setA11yContent: PropTypes.func.isRequired,
  showModal: PropTypes.bool,
  fetchPageContent: PropTypes.func.isRequired,
  pageContent: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};

const Container = styled(CommonContainer)`
  margin: 0px 0px 0px 20px;
  padding: 64px 20px ;
  ${media.mobile`
  margin: "0";
    padding: 48px 16px ;
  `}
`;


const HeaderDesc = styled.p`
  font-size: 14px;
  line-height: 16.8px;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;

  p {
    font-family: "Verizon NHG TX", Helvetica, Arial, sans-serif;;
    margin-bottom: 20px;

    :nth-child(4) {
      margin-bottom:0px;
    }
  }

  p:first-child {
    font-weight: 700;
    font-size: 24px;
    line-height: 28px;
  }

  ${media.mobile`
    width: 100%;
    font-size: 16px;
    line-height: 20px;
  `}
`;

const ButtonContainer = styled.div`
  margin-top: 48px;
  display: flex;
  button,
  a {
    width: 172px;
  }
  ${media.mobile`
   flex-direction: column;
  `}
`;

const Header = styled.h1`
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 24px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;

${media.mobile`
  font-size: 32px;	
  line-height: 36px;
  font-family:'Verizon NHG DS', Helvetica, Arial, sans-serif;
`}
`;
